export default __webpack_public_path__ + "static/media/manual25.74a014d2.png";